/** @module Camunda/TaskActionIconRenderer */ 
define([
	"dojo/_base/declare",
	"csi/heading/Enum",
	"csi/widget/icon/Util"
], function(declare,Enum,iconUtil) {

	return declare(Enum, {

		/**
		 * @override
		 * Render icon rather than the text
		 */
		toHtmlDynamic: function(ctx, h, refNode, params) {
			params.labelType = "html";
			params.labelFunc = function(item, store) {
				const id = store?.idProperty || "id";
				return iconUtil.getTaskActionIconHtml(item[id]);
			};

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Render icon
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			refNode.innerHTML = iconUtil.getTaskActionIconHtml(ctx.getNode().Icon);
			return true;
		},

		/** React */

		/**
		 * @param {context} ctx
		 * @return {string}
		 */
		getReactControlType: function(ctx) {
			return "Camunda/TaskActionIconInlineSelect";
		},

	});
});